import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import Layout from "@/components/Layout";
import { http } from "@/lib/api";
import { toast } from "sonner";

export default function ResetPassword() {
  const [search] = useSearchParams();
  const initialToken = search.get("token") || "";
  const [token, setToken] = useState(initialToken);
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters."); return; }
    if (password !== confirm) { toast.error("Passwords don't match."); return; }
    setLoading(true);
    try {
      await http.post("/auth/reset", { token, password });
      toast.success("Password updated. Please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid or expired link. Request a new one.");
    } finally { setLoading(false); }
  };

  return (
    <Layout>
      <section className="bg-[#050505] min-h-[80vh] py-24">
        <div className="max-w-[520px] mx-auto px-6 lg:px-10">
          <div className="font-ui text-[11px] tracking-[0.32em] text-[#C9A055] mb-3">Reset Password</div>
          <h1 className="font-display text-5xl text-[#F4F1EA] mb-2">NEW PASSWORD.</h1>
          <p className="font-script text-[#C9A055] text-2xl mb-8">A fresh start.</p>

          <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
            {!initialToken && (
              <input
                data-testid="reset-token"
                required
                placeholder="Paste your reset token"
                value={token}
                onChange={e => setToken(e.target.value)}
                className="stc-input font-mono text-sm"
              />
            )}
            <input
              data-testid="reset-password"
              required
              type="password"
              minLength={6}
              placeholder="New password (min 6 chars)"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="stc-input"
            />
            <input
              data-testid="reset-confirm"
              required
              type="password"
              placeholder="Confirm new password"
              value={confirm}
              onChange={e => setConfirm(e.target.value)}
              className="stc-input"
            />
            <button data-testid="reset-submit" disabled={loading} className="btn-gold w-full">
              {loading ? "Updating…" : "Update password"}
            </button>
            <div className="font-ui-tight text-sm text-[#B5B0A7]">
              <Link to="/login" className="text-[#C9A055] hover:text-[#E0BC72]">← Back to sign in</Link>
            </div>
          </form>
        </div>
      </section>
    </Layout>
  );
}
